module.exports = __webpack_public_path__ + "img/Image 11.8ef6c3b5.png";